// extracted by mini-css-extract-plugin
export default {"emptyContainer":"emptyContainer---fWp4e"};